"use strict";
exports.__esModule = true;
exports.chart_color_purple_500 = {
  "name": "--pf-v5-chart-color-purple-500",
  "value": "#2a265f",
  "var": "var(--pf-v5-chart-color-purple-500, #2a265f)"
};
exports["default"] = exports.chart_color_purple_500;